<div
    [id]="innerId"
    class="edInputFile d-flex justify-content-center text-center"
    (click)="fileInputDrag.click()"
    (appDropZone)="upload($event)"
    onkeypress="">
    <input #fileInputDrag type="file" (change)="uploadByEvent($event)" hidden />
  
    <div *ngIf=" !file?.name">
        <div class="circle-gray-light">
            <div class="circle-gray">
                <i class="bi bi-cloud-arrow-up" style="font-size: 2em"></i>
            </div>
        </div>

        <div><strong>Cliquez pour télécharger</strong> ou glissez-déposez votre fichier</div>
        <div *ngIf="allowedFormat">
            {{ allowedFormat.join(', ') }}
        </div>
    </div>
    <div *ngIf="file && file?.name" class="file-preview">
        <button class="close-button" (click)="removeFile($event)">
            <i class="bi bi-x-lg"></i>
        </button>
        <div class="circle-gray-light">
            <div class="circle-gray">
                <i class="bi bi-cloud-arrow-down" style="font-size: 2em"></i>
            </div>
        </div>

        <div><strong>{{file.name}}</strong></div>
        <div><strong>Cliquez pour télécharger</strong> ou glissez-déposez un autre fichier</div>
        <div *ngIf="allowedFormat">
            {{ allowedFormat.join(', ') }}
        </div>
    </div>
</div>
